'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.postFormat = exports.transposeChord = exports.getScale = undefined;

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

exports.SongToAgamaConverter = SongToAgamaConverter;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** vraci n pocet mezer */
var getSpaces = function getSpaces(count) {
    var a = [];
    for (var i = 0; i < count; i++) {
        a.push(' ');
    }
    return a.join('');
};

/** odstrani zobacky, aby nebylo HTML
 * @param {string} str
 * @returns {string}*/
var removeHtml = function removeHtml(str) {
    if (str == null) return null;
    if (str.length > 10000) //částečná ochrana
        str = str.substring(10000);
    return str.replace(/\&amp\;/g, '_$AGAMA$0').replace(/\</g, "").replace(/\>/g, "").replace(/\&/g, "&amp;").replace(/\_\$AGAMA\$0/g, "&amp;");
};

/** vraci unikatni
 * @param {Array} arrArg
 * @returns {Array}
 * */
var distinct = function distinct(arrArg) {
    return arrArg.filter(function (elem, pos, arr) {
        return arr.indexOf(elem) == pos;
    });
};

/** @returns {number} */ //TODO: asi se nepouziva
var isHalb = function isHalb(chord) {
    var increment = 0;
    if (chord.length > 1) {
        var second = chord.charAt(1);
        if (second == '#' || second == '♮') {
            increment += 1;
        }
        if (second == 'b' || second == 's' || second == '♭') {
            increment -= 1;
        }
    }
    return increment;
};

/** vraci klic z daného akordy - napřiklad C#; Pozor - nenormalizuje sufix b na # !!!! TODO
 * @param {string} chord
 * @returns {string}
 */
var getChordBase = function getChordBase(chord) {
    var withMoll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (chord.length == 1) return chord;
    var secondChar = chord[1];
    var mollSuffix = '';
    if (withMoll) {
        var s = chord.substr(0, 4);
        if (s.indexOf("m") > -1 && s.indexOf("maj") === -1) mollSuffix = "m";
    }

    if (secondChar === '#' || secondChar === 'b') return chord[0] + chord[1] + mollSuffix;
    return chord[0] + mollSuffix;
};

/** Vytvoří základní tabulky pro kadency písne
 */
var iniCadenceTables = function iniCadenceTables() {
    //TODO: co kdyz v písní bude suffix - treba Db - tak kadency urcime spatně !!!!!!! - normalizovat v metode getChordBase
    var notations = [{ notation: 'CZ', pole: ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "B", "H", "C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "B", "H"] }, { notation: 'INT', pole: ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "Bb", "B", "C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "Bb", "B"] }];
    //http://dusan.pc-slany.cz/hudba/kadence.htm  C F G Ami Emi Dmi
    //priklady: http://www.agama2000.cz/8qspftych4jwkwdh7xadijklmnq/Karel%20Gott/6xos7yedrdcmux7iqxabehijkoq/Jsem%20na%20sv%C4%9Bt%C4%9B%20r%C3%A1d
    //          http://www.agama2000.cz/8qspftych4jwkwdh7xadijklmnq/Karel%20Gott/pfqgh3nq7felrsvkrxcefilmnpq/K%C3%A1vu%20si%20oslad%C3%ADm
    var all = [];
    notations.forEach(function (obj) {
        var pole = obj.pole;
        /** vraci toninu, dominantu, dubdominantu  + molové; @returns {Array.<string>}*/
        var getSet = function getSet(i) {
            return [pole[i], pole[i + 5], pole[i + 7], pole[i + 9] /*Ami*/ + "m", pole[i + 4] /*Emi*/ + "m", pole[i + 2] /*Dmi*/ + "m"];
        };
        for (var k = 0; k < 12; k++) {
            all.push({ notation: obj.notation, cadence: getSet(k) });
        }
    });
    return all;
};
/** Odstranuje bckové akordy a nahrazuje je krizkovymi pro spravne urceni kadence */
var standardizeChordsForCadency = function standardizeChordsForCadency(chordBase) {
    return chordBase.replace('Db', 'C#').replace('Eb', 'D#').replace('Gb', 'F#').replace('Ab', 'G#');
};

/** tabulka kadencí @type {Array.<Array.<string>>} */
var cadenceTables = iniCadenceTables();

/** automaticky odvozuje toninu - vraci kadency
 * @param {Array.<string>} allChords
 * @returns {Array.<string>}
 */
var detectBestCadency = function detectBestCadency(allChords) {
    //zjistim vsechny akordove báse včetně molového suffixu
    var chords = distinct(allChords.map(function (ch) {
        return standardizeChordsForCadency(getChordBase(ch, true));
    }));
    var comparer = function comparer(x, y) {
        return y.matches - x.matches;
    };
    var bestCadences = cadenceTables.map(function (cadenceObj, i) {
        var matches = 0;
        chords.forEach(function (ch) {
            if (cadenceObj.cadence.indexOf(ch) > -1) matches++;
        });
        return { cadence: cadenceObj, matches: matches };
    }).sort(comparer);

    //automaticky detekovana tonina
    var bestOne = bestCadences[0];
    return bestOne;
};

/** vraci stupnici pro danou notaci */
var getScale = exports.getScale = function getScale(notation) {
    var scales = {
        CZ: ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "B", "H", "C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "A#", "H", "C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Hb", "H"],
        INT: ["A", "Bb", "B", "C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B", "C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab"]
    };
    return scales[notation];
};

/** transponuje jeden akord
 * @param {string} chord akord k transponovani.
   @param {number|string} targetOrIncrement 
   @param {boolean} [force = false] vynutit transponovani i když není potřeba
 */
var transposeChord = exports.transposeChord = function transposeChord(chord, targetOrIncrement) {
    var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var notationSource = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'CZ';
    var notationTarget = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'CZ';

    var targetChords = {
        CZ: ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "B", "H", "C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "A#", "H"],
        INT: ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "Bb", "B", "C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "A#", "B"]
    };
    var sourceAlternatives = {
        CZ: ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "H", "C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "B", "H", "C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Hb", "H", "C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Bb", "H"],
        INT: ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B", "C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Bb", "B", "C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Hb", "H"]
    };

    //const cycle = targetChords[notationTarget].concat(sourceAlternatives[notationSource]);

    var delta = void 0;
    var chordBase = getChordBase(chord);
    var chordBaseIndex = sourceAlternatives[notationSource].indexOf(chordBase) % 12; //musi se najit v sourceAlternatives
    if (chordBaseIndex === -1) return null; //neni akord;
    if (typeof targetOrIncrement == 'number') {
        delta = targetOrIncrement;
    } else {
        var targetBase = getChordBase(targetOrIncrement);
        var targetBaseIndex = targetChords[notationTarget].indexOf(targetBase) % 12; //musi se najit v sourceAlternatives
        delta = targetBaseIndex - chordBaseIndex;
    }
    while (delta > 12) {
        delta = delta - 12;
    }while (delta < 0) {
        delta = delta + 12;
    }if (delta == 0 && !force) return { chord: chord, increment: delta };
    var newOffset = chordBaseIndex + delta;

    var targetBase2 = targetChords[notationTarget][newOffset % 12];
    var length = targetBase2.length;
    var result = targetBase2 + chord.substring(chordBase.length);
    return { chord: result, increment: delta };
};

// ctor
function SongToAgamaConverter() {
    // abychom meli pristup k vnejsi tride
    var converterSelf = this;

    var inword = /[\S]$/;
    var chordregex = /(\[[A-H]{1}[^\]]*\])/; //pouziva se jen pro chordPro - protoze jsou tam zavorky, neni nutny tak dukladná analyza
    //const startHeaders = /^([\.|:|\)]?(([\d][\d]{0,2})|(r(ef)?\ ?(\d)?)|(ver(s|z)e|\*(\d)?|rf(\d)?|intro|outro|rec(\d)?|recitace(\d)?|recit(\d)?|®(\d)?|mezihra|ona|on|oba|(bridge\ ?(\d)?)|(chor(us)?\ ?(\d)?)|\(r\))))[\.|:|\)]{1,2}/i;
    var startHeaders = /(^[\.:\)]?(break|pre[\-]?chorus|refrain|ref|rf|r|ver(z|s)e|ver|chorus|chor|bridge|intro|coda|outro|recitace|rec|fade|out|sbor|mezihra|\*|\®)?\ ?\d{0,2}[\.:\)]{1,2})|(^\®)|(^\ ?\[(?!\:).+?(?=\])\])/i;
    var startTabelatura = /^[CDEFGAHx]?[b#]?\|(?!\:)/i;
    var startSpecialSymbol = /^(CAPO)\ {0,2}(\d{1,2}|III|II|IV|I|VIII|VII|VI|V)/i;
    var youtubeVideo = /^\#?\ *http(s)?\:\/\/(www\.)?youtube\.com\/watch\?v=[a-zA-Z0-9_\-]{5,15}/i;
    var directivesReg = /^\#(CZ|INT|LANG)/i;

    var replaceObsoleteChords = function replaceObsoleteChords(chord) {
        var rchord = chord;
        if (chord.indexOf('s') === 1 && chord.indexOf('sus') === -1) rchord = chord[0] + 'b' + rchord.substring(2);
        if (chord.indexOf('mi') > 0) rchord = chord.replace(/mi/g, 'm');
        if (chord.indexOf('moll') > 0) rchord = chord.replace(/moll/g, 'm');
        if (chord.indexOf('moll') > 0) rchord = chord.replace(/moll/g, 'm');
        //if (chord.startsWith('H') > 0) rchord = 'B' + chord.substring(1);
        return rchord;
    };

    var countLeadingSpaces = function countLeadingSpaces(str) {
        return str.match(/^(\s*)/)[1].length;
    };

    var normalizeHeader = function normalizeHeader(header) {
        var forFinalView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (header.trim().length === 0) return '';
        var a = header.replace('[', '').replace(']', '').replace(/(refrain|ref|rf|chorus|chor|®)/i, 'R').replace(/[\.\:\ ]/g, '').replace(/ver(z|s)e/i, 'ver').replace(/ver/i, 'verse');
        var ver = a.match(/verse\d{1,2}/i);
        if (ver != null) {
            a = a.replace(/verse/i, '');
        }

        return forFinalView ? a + ':' : a;
    };

    var chordLineSeparators = /^( *|\)|\(|,|\/)$/;
    // var chordLineReg = /([A-H][#|b]?[^( |\)|\(|,|\/)]*)/;
    var chordLineReg = /([A-H]\d?\d?[#|b]?(|mmaj||Maj|maj|min|moll|m(i)?|moll|dim|sus|s|(m)?min|add|(A|a)ug)?(\d{0,2})(add|\(th\))?[^( |\)|\(|,|\/|a|c-z)]*)/;

    //const dirtyChordReg = /(\s+)|[\(\(\|\/\\\,]|([^\(\(\|\/\\\,]+)/g; //   saved regex https://regex101.com/r/8sWHpN/1
    //see: //http://www.all-guitar-chords.com/
    //saved regex https://regex101.com/r/8sWHpN/3
    var wholeChordLineReg = /(\ +)|[\(\)\|\/\\\,\ ]|(\{.+?(?=\})\})|((C#|C|Db|D#|D|Eb|E|F#|F|Gb|G#|G|Ab|A#|A|Bb|B|Hb|H)(♮|♭|s(?!us)|es|is)?(maj7|maj9|(4|5|6|7|9|11|13|m(i)?)(\+|\-)?([\-\+\/](4|5|6|7|9|11|13)(\+|\-)?)|mmaj|moll|min|major|Maj|maj|m(i)?(\+|\-)?(4|5|6|7|9|11|13)?|sus2sus4|7sus4|7sus|4sus|sus4|2sus|sus2|sus|dim7|dim|add|6add9|add9|aug|((\+|\-)?(4|5|6|7|9|11|13)(\+|\-)?)|\+|\-)?([#|b]([1-9]?[1-3]?))?(\'){0,10})/g;
    var multiChordSeparators = /[\(\)\|\/\\\,\ \{\}]/;
    var checkChordLine = function checkChordLine(line) {

        line = line.trimRight();
        var matched = line.match(wholeChordLineReg);
        if (!matched) return null;
        //const text = ' A   Bb7   (B7) Ab  A#  Dsus  Cmin Cmaj Cmoll D# D/E DDdim  E6addDaddE7   Amaj13 D11 D(E)  A,B) FGmi Dmi Cmi13  Dmi13#11 D#13#11A D# G# C# A9b5';
        var lineOnlyChords = matched.join('');
        if (line !== lineOnlyChords) return null;
        //ted uz vime, ze radek je slozen jen ze samych akordu
        //nasleduje seskupeni jednotlivych znacek ve skupiny (kazda skupina ma jednu kotvu)
        var groups = [];
        var pureChords = [];
        var currentGroup = { marks: [], markTypes: [], offset: 0 };
        var offset = 0;
        var inGroupOffset = 0;
        var groupMustContinue = false;

        var _loop = function _loop() {
            var mark = matched[n];
            var isSpaces = mark.trim().length === 0;
            var checkSeparatorF = function checkSeparatorF() {
                var res = mark.match(multiChordSeparators);
                if (res == null) return false;
                return res.index === 0;
            };
            var isSeparator = isSpaces ? false : checkSeparatorF(); //=pouze oddelujici znaky
            var isNewGroup = isSpaces || !isSeparator && !groupMustContinue; //po mezere nebo po zmene akordu je nova skupina, napr: DmiCmi 
            var isSpecial = mark.startsWith('{');
            var markType = isSpecial ? 2 : isSeparator ? 1 : 0;
            if (isSpecial) {
                mark = mark.substring(1, mark.length - 1);
                offset = offset + 2;
            }
            if (markType === 0 /*normalni akord*/) {
                    mark = mark.replace(/♭/g, 'b').replace(/♮/g, '#').replace(/is/, '#').replace(/es/, 'b').replace(/s(?!us)/, 'b').replace(/sub/, 'sus');
                }
            groupMustContinue = isSeparator;
            if (isNewGroup) {
                inGroupOffset = 0;
                if (currentGroup.marks.length > 0) //radek zacinajici , je divný TODO: dovolit ?
                    groups.push(currentGroup);
                if (isSpaces) offset += mark.length;
                currentGroup = { marks: [], markTypes: [], offset: offset }; //TODO: mode funguje blbě
                if (isSpaces) return 'continue';
            }
            currentGroup.marks.push(mark);
            currentGroup.markTypes.push(markType);
            if (!isSeparator) {
                //cisty akord, napr: Dmi
                pureChords.push({ marks: currentGroup, value: mark, offset: inGroupOffset });
            }

            offset += mark.length;
            inGroupOffset += 1;
        };

        for (var n = 0; n < matched.length; n++) {
            var _ret = _loop();

            if (_ret === 'continue') continue;
        } //endof for

        if (currentGroup.marks.length > 0) groups.push(currentGroup);

        return { chordObj: groups, pureChords: pureChords };
    };

    this.convertToAgama = function (txt) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var song = new SongObj(txt, params);
        return song;
    };

    // ctor
    function SongObj(txt) {
        var _this = this;

        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        /*eslint-disable */
        var self = this;

        var getVideoCode = function getVideoCode(youtubeUrl) {
            var a = youtubeUrl.indexOf('=');
            return youtubeUrl.substring(a + 1);
        };

        var process = function process(buffer) {
            //sgrupuje normalizovane sekvence agama radek do slok, jmena slok normalizuje
            var normalizedLines = buffer;
            var longestPartName = ' ';
            var all = [];
            var partName = ' ';
            var part = [];
            var posun = 0;
            var videos = [];
            var directives = {};
            normalizedLines.forEach(function (line) {
                var lineTrim = line.trim();
                var chordCompleteObj = checkChordLine(line);
                var pureChords = chordCompleteObj ? chordCompleteObj.pureChords : [];
                var chordObj = chordCompleteObj ? chordCompleteObj.chordObj : [];
                var isChordLine = chordObj.length > 0;
                var prevChordLine = part[part.length - 1];
                if (prevChordLine && prevChordLine.chordObj.length == 0) prevChordLine = null; //predchozi radka neni akordova.
                if (lineTrim == "" || lineTrim.match(startHeaders) && !lineTrim.startsWith('http')) {
                    var spl = line.split(startHeaders);
                    var zbytekRadky = spl[spl.length - 1]; //zbytek radky vznikne po odriznuti jmena sloky
                    posun = line.length - zbytekRadky.length;
                    if (part.length > 0) {
                        //pokud je potreba predchzoi cast ulozit
                        all.push({ name: partName, lines: part });

                        if (prevChordLine && lineTrim != "") {
                            //predhcozi radka (z predchozi sloky) byla akordova, a ta patri k nasledujici sloce
                            part.length = part.length - 1; //pokud ale pouzivame jen zbytek po odriznuti zacatku sloky, predch. akordova radka se take posune.
                            if (part.length == 0) all.length = all.length - 1; // v predchozi sloce by nic nezbylo
                            var prevLine = prevChordLine.text.substring(posun);
                            var chordCompleteObjPrev = checkChordLine(prevLine);
                            if (chordCompleteObjPrev) part = [{ text: prevLine, chordObj: chordCompleteObjPrev.chordObj, pureChords: chordCompleteObjPrev.pureChords }];else //po odriznuti jmena sloky se nakonec zda, že nejde o akord
                                part = [{ text: prevLine, chordObj: [], pureChords: [], isTab: false, isSpecialSymboled: false }];
                        } else {
                            part = [];
                        }
                    }
                    partName = normalizeHeader(line.substring(0, posun), true);
                    if (partName.length > longestPartName.length) longestPartName = partName;

                    if (zbytekRadky.length > 0) {
                        var withFakeHeader = prevChordLine ? zbytekRadky : getSpaces(posun) + zbytekRadky;
                        chordCompleteObj = checkChordLine(withFakeHeader);
                        chordObj = chordCompleteObj ? chordCompleteObj.chordObj : [];
                        pureChords = chordCompleteObj ? chordCompleteObj.pureChords : [];
                        part.push({ text: withFakeHeader, chordObj: chordObj, pureChords: pureChords });
                    }
                } else {
                    //radka v sloce, odrizneme padding
                    var odsazeni = countLeadingSpaces(line);
                    if (posun > 0 && !isChordLine) {
                        odsazeni = countLeadingSpaces(line);
                        var minPosun = Math.min(odsazeni, posun);
                        if (prevChordLine) //akord mohl byt pred textem:
                            minPosun = Math.min(minPosun, countLeadingSpaces(prevChordLine.text));
                        if (minPosun != 0) {
                            line = line.substr(minPosun);
                            if (prevChordLine) {

                                prevChordLine.text = prevChordLine.text.substring(minPosun);
                                var chordCompleteObjPrev = checkChordLine(prevChordLine.text);
                                prevChordLine.chordObj = chordCompleteObjPrev.chordObj;
                                prevChordLine.pureChords = chordCompleteObjPrev.pureChords;
                            }
                        }
                    }

                    var video = lineTrim.match(youtubeVideo);
                    if (video) {
                        videos.push(getVideoCode(video[0]));return;
                    }

                    var directive = lineTrim.match(directivesReg);
                    if (directive) {
                        var dname = directive[0].substring(1);
                        var dvalue = directive.input.substring(dname.length + 1).trim() || true;
                        directives[dname] = dvalue;
                        return;
                    }
                    if (lineTrim.startsWith('#')) return;

                    var isTab = lineTrim.match(startTabelatura) != null;
                    var isSpecialSymboled = lineTrim.match(startSpecialSymbol) != null;
                    part.push({ text: line, chordObj: chordObj, pureChords: pureChords, isTab: isTab, isSpecialSymboled: isSpecialSymboled });
                }
                //ulozime si radku jako akordovou
                //prevChordLine = isChordLine ? { text: line, chordObj: chordObj } : null;

            });
            if (part.length > 0) all.push({ name: partName, lines: part });

            //najdem všechny akordy
            var poleVsechAkordu = [];
            all.forEach(function (part) {
                var trailingSpaces = 0;
                part.lines.forEach(function (line) {
                    (line.pureChords || []).forEach(function (chord) {
                        return poleVsechAkordu.push(chord);
                    });
                    trailingSpaces = Math.min(countLeadingSpaces(line.text), trailingSpaces);
                });
                part.lines.forEach(function (line) {
                    line.text = line.text.substring(trailingSpaces);
                    line.chordObj.forEach(function (x) {
                        return x.offset = x.offset - trailingSpaces;
                    });
                });
            });

            return {
                parts: all,
                longestPartName: longestPartName,
                allChords: poleVsechAkordu,
                videos: videos,
                directives: directives
            };
        };

        var trimPart = function trimPart(partObj, bypassTrimStart, bypassTrimEnd) {

            //console.log('Trimming part '+ JSON.stringify(partObj.lines[0]));
            if (!bypassTrimStart) while (partObj.lines.length > 0 && partObj.lines[0].text.trim().length == 0) {
                partObj.lines.shift();
            }
            //odmazeme prazdne radky na koncech slok 
            if (!bypassTrimEnd) while (partObj.lines.length > 0 && partObj.lines[partObj.lines.length - 1].text.trim().length == 0) {
                partObj.lines.length--;
            }
        };

        var toSearch = function toSearch(model) {

            var all = model.parts;
            var buf = [];
            all.forEach(function (partObj) {
                trimPart(partObj);
                partObj.lines.forEach(function (line) {
                    if (line.chordObj.length == 0) {
                        var linet = line.text.trim().replace(/\-/g, '').replace(/\_/g, '').replace(/\./g, ' ').replace(/\-/g, '');
                        while (linet.indexOf('  ') > -1) {
                            linet = linet.replace(/\ \ /g, ' ');
                        } //.replace(/  /g,' ');
                        if (linet.length > 10) buf.push(linet.toLowerCase());
                    }
                });
            });
            return buf.join(' ').substring(0, 900); //ve vetsim souboru nebudem hledat.
        };

        var toText = function toText(model, usePadding) {
            if (!usePadding) usePadding = false;
            var all = model.parts;
            var paddingLength = model.longestPartName.length + 1;
            var emptyPadding = '';while (emptyPadding.length < paddingLength && usePadding) {
                emptyPadding = emptyPadding + ' ';
            }var n = 0;
            var buf = [];
            all.forEach(function (partObj) {
                if (n++ > 0) buf.push('');
                if (!usePadding) {
                    buf.push(partObj.name + ' ');
                }
                var print = false;
                var padding = usePadding ? partObj.name + ' ' : '';
                while (padding.length < paddingLength && usePadding) {
                    padding = padding + ' ';
                }trimPart(partObj);
                var hasTextLine = partObj.lines.some(function (line) {
                    return line.chordObj.length == 0;
                });
                partObj.lines.forEach(function (line) {
                    if (!hasTextLine /*sloka obsahovala jen akordy, tudiz by jinak nedoslo k vyti�t�n� n�zvu sloky*/ || !print && line.chordObj.length == 0) {
                        buf.push(padding + line.text);
                        print = true;
                    } else buf.push(emptyPadding + line.text);
                });
            });
            return buf.join('\n');
        };

        var mergeLines = function mergeLines(chordObj, lineText, wrapMarksF, wrapMiddleTextF) {
            var shift = 0;

            var length = lineText.length;
            var linePartMark = '|%{u}%|'; //libovolná nevyskytujícíse značka

            chordObj.forEach(function (marksOnOffset) {
                var mark = wrapMarksF(marksOnOffset);

                var delta = marksOnOffset.offset - length;
                while (delta-- >= 0) {
                    lineText += ' ';
                    length++;
                    //console.log(">"+n++);
                }

                //lineText = lineText.substring(0, marksOnOffset.offset + shift) + mark + lineText.substr(marksOnOffset.offset + shift);
                var beforeText = lineText.substring(0, marksOnOffset.offset + shift);
                var afterText = lineText.substr(marksOnOffset.offset + shift);
                lineText = beforeText + linePartMark + mark + afterText;

                shift += mark.length + linePartMark.length;
            });
            lineText = (linePartMark + lineText + linePartMark).split(linePartMark).map(wrapMiddleTextF).join('');

            return lineText;
        };

        var wrapMarksForChordProFormat = function wrapMarksForChordProFormat(marksOnOffset) {
            return '[' + marksOnOffset.marks.join('') + ']';
        };
        var wrapLinesForChordProFormat = function wrapLinesForChordProFormat(line, hasChords) {
            return line.replace(/\_/g, '');
        };
        var wrapPartChordProFormat = function wrapPartChordProFormat(partName, part) {
            if (partName.trim().length === 0) return '\n' + part;
            return '[' + partName.replace(':', '') + ']\n' + part;
        };

        var wrapMiddleTextChordProFormat = function wrapMiddleTextChordProFormat(middleText) {
            return middleText;
        };

        var wrapMarksForHTMLFormat = function wrapMarksForHTMLFormat(marksOnOffset) {

            var markTypes = marksOnOffset.markTypes;
            //mode=0..prvni je akord 'Dmi/Emi
            //mode=1..prvni je znacka: napr: '(A)'
            var n = 0;
            var parts = marksOnOffset.marks.map(function (mark, i) {
                var markType = markTypes[i];
                if (markType === 2) return '<em>' + mark + '</em>';
                if (markType === 1) return '<i>' + mark + '</i>';
                return '<u>' + mark + '</u>';
            });

            return '<sup><b>' + parts.join('') + '</b></sup>';
        };
        var wrapLinesForHTMLFormat = function wrapLinesForHTMLFormat(line, hasChords, isUponText) {
            //console.log(line)
            if (line.startsWith(' ') || line == '') line = '&nbsp;' + line.substring(1); //aby tam byl alespon jeden tvrdej znak, jinak bude vyska radku 0.
            //jedno podržítko necháme.
            //while (line.indexOf('__') > -1) line = line.replace(/\_\_/g, '_');
            //if (line.endsWith("_")) line = line = line.substring(0,line.length-2); //Agama 2016 pridan radek
            //posledni podržítko nahradíme elementem
            //line = line.replace(/\_/g, '<span>_</span>'); //Agama 2016 zakomentovano
            return hasChords ? isUponText ? '<span class="line chorded aloneChorded">' + line + '</span><br />' : '<span class="line chorded ">' + line + '</span><br />' : '<span class="line">' + line + '</span><br />';
        };
        var wrapPartForHTMLFormat = function wrapPartForHTMLFormat(partName, part) {
            var advClass = '';
            if (partName != null && partName.startsWith('R') && !partName.startsWith('Rec')) advClass = 'refren';
            if (advClass.length > 0) advClass = ' ' + advClass;

            return '<div class="part ' + advClass + '"><table><tr><td class="partName">' + partName + '</td><td>' + part + '</td></tr></table></div>';
        };

        var wrapMiddleTextHTMLFormat = function wrapMiddleTextHTMLFormat(middleText) {
            if (middleText === '') return middleText;
            // if (middleText.startsWith(' '))
            // middleText = '&nbsp;' + middleText.substring(1); //aby tam byl alespon jeden tvrdej znak, jinak bude vyska radku 0.
            // return '<span class='middleLine'>' + middleText + '</span>';
            return '<span class="middleLine">' + middleText.replace(/\ /g, '&nbsp;') + '</span>';
        };
        var wrapTabHTMLFormat = function wrapTabHTMLFormat(middleText) {
            return '<span class="line tab">' + middleText + '</span>';
        };
        var wrapSpecsHTMLFormat = function wrapSpecsHTMLFormat(middleText) {
            return '<span class="specialSymboled">' + middleText + '</span>';
        };

        var toMergedFormat = function toMergedFormat(model, wrapMarksF, wrapLinesF, wrapPartF, wrapMiddleTextF, wrapTabF, wrapSpecsF) {
            var all = model.parts;
            var allBuf = [];
            if (wrapMarksF == null) wrapMarksF = wrapMarksForChordProFormat;
            if (wrapLinesF == null) wrapLinesF = wrapLinesForChordProFormat;
            if (wrapPartF == null) wrapPartF = wrapPartChordProFormat;
            if (wrapMiddleTextF == null) wrapMiddleTextF = wrapMiddleTextChordProFormat;
            if (wrapTabF == null) wrapTabF = wrapMiddleTextChordProFormat;
            if (wrapSpecsF == null) wrapSpecsF = wrapMiddleTextChordProFormat;

            all.forEach(function (partObj) {
                var buf = [];
                var previousChordObj = null;
                var chordObj = null;
                trimPart(partObj);
                var hasTextLine = partObj.lines.some(function (line) {
                    return line.chordObj.length == 0;
                });
                partObj.lines.forEach(function (line) {

                    if (line.isTab) {
                        buf.push(wrapTabF(line.text));
                        return;
                    }
                    if (line.isSpecialSymboled) {
                        buf.push(wrapSpecsF(line.text));
                        return;
                    }

                    var isChordLine = line.chordObj.length > 0;
                    if (isChordLine) {
                        chordObj = line.chordObj;

                        if (previousChordObj != null) {
                            //radek je akordovy, ale predchzoi taky
                            var wrappedLine0 = mergeLines(previousChordObj, ' ', wrapMarksF, wrapMiddleTextF);
                            buf.push(wrapLinesF(wrappedLine0, true, true));
                        }
                        previousChordObj = chordObj;
                    } else {

                        if (chordObj) {
                            var wrappedLine = mergeLines(chordObj, line.text, wrapMarksF, wrapMiddleTextF);
                            buf.push(wrapLinesF(wrappedLine, true));
                        } else buf.push(wrapLinesF(line.text, false));
                        chordObj = null;
                        previousChordObj = null;
                    }
                });
                //akordovy radek, ktery nebyl nasledovan textem, ulozime jej take.
                if (chordObj) {
                    var wrappedLine2 = mergeLines(chordObj, ' ', wrapMarksF, wrapMiddleTextF);
                    buf.push(wrapLinesF(wrappedLine2, true));
                }

                allBuf.push(wrapPartF(partObj.name, buf.join('\n')));
            });
            return allBuf.join('\n');
        };

        var loadChordProFormatIntoBuffer = function loadChordProFormatIntoBuffer(text) {
            var buffer = [];
            var leadingSpaces = null;
            var savePartNameRescuer = '0%@@%0';
            var addLine = function addLine(line) {
                var lineT = line.replace(savePartNameRescuer, '').trimRight();
                var j = countLeadingSpaces(lineT);
                if (leadingSpaces == null || j < leadingSpaces) if (lineT.length > 0) leadingSpaces = j;
                buffer.push(lineT);
            };

            var applyChordLine = function applyChordLine(line) {
                var i = 0;
                var chords = '';
                var lyrics = '';
                var chordlen = 0;
                var paddingSpaces = '_________________________';

                var splitted = line.split(chordregex);
                splitted.forEach(function (word, pos) {
                    var dash = 0;
                    /* Lyrics */
                    if (pos % 2 == 0) {
                        lyrics = lyrics + word;
                        var m = splitted;
                        // Whether or not to add a dash (within a word)
                        if (word.match(inword) && pos + 1 < splitted.length) {
                            dash = 1;
                        }
                        // Apply padding.  We never want two chords directly adjacent, so unconditionally add an extra space.
                        if (word.length < chordlen) {
                            chords = chords + ' ';
                            //lyrics = (dash == 1) ? lyrics + '__' : lyrics + '  ';
                            //lyrics = (dash == 1) ? lyrics + paddingSpaces.substring(0,chordlen-word.length+1) : lyrics + '__';
                            lyrics = lyrics + paddingSpaces.substring(0, chordlen - word.length + 1);
                            //for (i = chordlen - word.length - dash; i != 0; i--) {
                            //    var sp = dash == 1 ? '_' : ' ';
                            //    lyrics = lyrics + sp;
                            //}
                        } else if (word.length == chordlen && word.trim() != '') {
                            chords = chords + ' ';
                            lyrics = dash == 1 ? lyrics + '_' : lyrics + ' ';
                        } else if (word.length > chordlen) {
                            for (i = word.length - chordlen; i != 0; i--) {
                                chords = chords + ' ';
                            }
                        }
                    }
                    /* Chords */
                    else {
                            var chord = word.substring(1, word.length - 1);
                            chord = replaceObsoleteChords(chord);
                            chordlen = chord.length;
                            chords = chords + chord;
                        }
                });
                addLine(chords);
                addLine(lyrics);
                return;
            };

            var lines = text.split('\n').map(function (x) {
                return x.trimRight();
            });
            var znackaSlokyVHranatychZavorkachAleBezRepetice = /(^\ ?\[(?!\:).+?(?=\])\])/;
            var nasledujiciVolnouRadkuIgnorovat = false;
            //lines.forEach(function (line) { console.log('o>' + line); });
            lines.forEach(function (line, linenum) {
                if (nasledujiciVolnouRadkuIgnorovat && line.trim().length === 0) {
                    return;
                }
                nasledujiciVolnouRadkuIgnorovat = false;
                /* ignoring comments */
                if (line.match(/^#/)) {
                    buffer.push(line);
                    return;
                }
                // if (line.match(/^{.*}/)) {
                //     return;
                // }
                if (line.match(znackaSlokyVHranatychZavorkachAleBezRepetice)) {
                    nasledujiciVolnouRadkuIgnorovat = true;
                    addLine(line);
                    return;
                }

                /* Chord line */
                // const tmp = line.match(startHeaders);//TODO: pokracovat
                // if (tmp!=null) {
                //   const header = tmp[0];
                //   const normHeader = '['+savePartNameRescuer+normalizeHeader(header)+']'; //tim kod sloky ochranime pred dekodovanim jako akord
                //   const continuing =  line.substring(header.length);
                //   line = (normHeader + (continuing.length === 0 ? '' : continuing));
                // }

                if (line.match(chordregex) && !line.match(startHeaders)) {
                    applyChordLine(line);
                } else {
                    addLine(line);
                }
            });
            var normalizeLine = function normalizeLine(line) {
                var res = line.substring(leadingSpaces);
                while (res.endsWith("_")) {
                    res = res.substring(0, res.length - 1);
                };
                return res;
            };

            return buffer.map(normalizeLine);
        };

        this.getChords = function () {
            return _this.model.allChords.map(function (ch) {
                return ch.value;
            });
        };
        //   // vrací základní akordový klíč (B7 => B; C#mi => C#)  z kadence pisne
        //   this.getChordKey = ()=>{
        //     return self.analysis.chordKey;
        //     //const firstChord = this.model.allChords.length == 0 ? null : this.model.allChords[0].value;
        //     //if (!firstChord) return null;
        //     return  getChordBase(firstChord);
        //   }


        this.getText = function (usePadding) {
            return toText(this.model, usePadding);
        };
        this.getSearch = function () {
            return toSearch(this.model);
        };
        //this.getText = function () { return buffer.join('\n'); };
        this.getChordPro = function () {
            return toMergedFormat(this.model);
        };
        this.getHtml = function () {
            return toMergedFormat(this.model, wrapMarksForHTMLFormat, wrapLinesForHTMLFormat, wrapPartForHTMLFormat, wrapMiddleTextHTMLFormat, wrapTabHTMLFormat, wrapSpecsHTMLFormat);
        };

        var getChordAnalysis = function getChordAnalysis() {
            var directives = self.model.directives;
            var chords = distinct(self.getChords());

            var withoutMoll = chords.map(function (ch) {
                return getChordBase(ch);
            });
            var sourceNotation = null;
            if (directives.CZ) sourceNotation = 'CZ';
            if (directives.INT) sourceNotation = 'INT';
            if (!sourceNotation) {
                var hasH = withoutMoll.some(function (x) {
                    return x == "H";
                });
                var hasBb = withoutMoll.some(function (x) {
                    return x == "Bb";
                });
                var hasB = withoutMoll.some(function (x) {
                    return x == "B";
                });
                if (hasH) {
                    if (!hasBb) sourceNotation = 'CZ';
                }
            }
            //cadence = tonina , odvozena z harmonie pisne, nikoliv z prvniho akordu
            var cadence = detectBestCadency(chords);

            if (!sourceNotation) {
                sourceNotation = cadence.cadence.notation;
            }
            var keyChord = withoutMoll[0];
            if (cadence.matches >= 4) {
                //pokud je match u cadence >= 4, pak lze urcit toninu - jinak dle prvniho akordu
                keyChord = cadence.cadence.cadence[0];
            }

            return {
                sourceNotation: sourceNotation,
                keyChord: keyChord

            };
        };

        /** Transponuje model písně
         * @param {string|number} targetOrIncrement cílový akord nebo inkrement v pultonech
         */
        var transposeModel = function transposeModel(targetOrIncrement /*targetkey or increment*/) {
            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (self.model.allChords.length == 0) return;
            var sourceNotation = self.analysis.sourceNotation;
            var notationTarget = self.targetNotation;
            var currentKeyChord = self.analysis.keyChord;
            var increment = transposeChord(currentKeyChord, targetOrIncrement, force, sourceNotation, notationTarget).increment;
            if (increment === 0 && !force) return;

            self.model.allChords.forEach(function (chord, i) {
                var currentPureChord = chord.marks.marks[chord.offset];
                var chordType = chord.marks.markTypes[chord.offset]; //znacky mezi akordama nebo spearatory ignorujem
                if (chordType === 0) {
                    var obj = transposeChord(currentPureChord, increment, force, sourceNotation, notationTarget);
                    chord.marks.marks[chord.offset] = obj.chord;
                }
            });
        };
        this.transposeModel = transposeModel;

        /* vlastni zpracovani*/

        txt = removeHtml(txt).replace(/\t/g, '      '); //tab = 6 mezer;
        if (!txt.endsWith('\r\n')) txt = txt + '\r\n';
        this.raw = txt;

        var normalizedLines = loadChordProFormatIntoBuffer(txt);

        this.protoBuffer = normalizedLines.join('\n');
        this.model = process(normalizedLines);
        this.analysis = getChordAnalysis();

        this.targetNotation = params.targetNotation || 'CZ';

        transposeModel(0, true);

        /*eslint-enable */
    }
    //konec tridy SonGObj

}

//----------------------------------------
///nasleduje puvodni obsah ze souboru postFormatting 
//----------------------------------------


/*eslint-disable */
var setStyle = function setStyle(elem, key, value) {
    if (!value && elem.style[key]) {
        delete elem.style[key];
        return elem;
    }
    elem.style[key] = value;
    return elem;
};

var repairLine = function repairLine(lineElem) {
    var minimalniMezeraMeziAkordy = 4;
    var segments = (0, _from2.default)(lineElem.querySelectorAll('.middleLine'));
    var posun = 0;
    segments.forEach(function (seg) {
        var chord = seg.querySelector('sup b');
        if (!chord) return;
        //setStyle(seg, 'border', 'solid 1px cyan');
        //segWidth si musime pamatovat pred pridanim padingu
        var segWidth = seg.offsetWidth;
        if (posun > 0) {
            setStyle(seg, 'paddingLeft', posun + 'px');
            //setStyle(seg, 'border', 'solid 1px blue');
            posun = 0;
        }
        var delta = segWidth - chord.offsetWidth;
        //console.log(delta);
        if (delta <= minimalniMezeraMeziAkordy) posun += minimalniMezeraMeziAkordy - delta;

        //setStyle(seg, 'position', 'relative');
        //setStyle(seg, 'left', '-' + width + 'px');
        //setStyle(chord, 'position', 'relative');
        //setStyle(chord, 'left',  width + 'px');
        //console.log(width);

    });
};

var getAbsoluteHeight = function getAbsoluteHeight(el) {
    // Get the DOM Node if you pass in a string
    el = typeof el === 'string' ? document.querySelector(el) : el;

    var styles = window.getComputedStyle(el);
    var margin = parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']);

    return Math.ceil(el.offsetHeight + margin);
};

var findParentElement = function findParentElement(elem, predicate) {
    var res = elem;
    while (res != null && !predicate(res)) {
        res = res.parentElement;
    }
    return res;
};

var postFormat = exports.postFormat = function postFormat(elem) {

    var song = (0, _from2.default)(elem.classList).indexOf('songText') > -1 ? elem : (0, _from2.default)(elem.querySelectorAll('.songText'))[0];
    var tmp = (0, _from2.default)(elem.querySelectorAll('h1'));
    var title = tmp.length > 0 ? tmp[0] : null;
    var titleHeight = title ? getAbsoluteHeight(title) : 0;

    //song.classList.add("agamaflex");
    var parentScrollable = findParentElement(elem, function (x) {
        return x.classList.contains('scrollable');
    });
    var availableWidth = parentScrollable.offsetWidth;
    var availableHeight = parentScrollable.offsetHeight - titleHeight;
    var parts = (0, _from2.default)(elem.querySelectorAll('.part'));
    var requiredHeight = parts.reduce(function (a, b) {
        return a + b.offsetHeight;
    }, 0);

    var partSizes = parts.map(function (p) {
        //sirku sloky musime urcit dle nejdelsiho radku, protoze ve flex rezimu sloka zabira sirku vzdy celho sloupce
        var lineRects = (0, _from2.default)(elem.querySelectorAll('.line')).map(function (x) {
            return { w: x.offsetWidth + 60 /*cislo sloky*/, h: x.offsetHeight };
        });
        var pw = lineRects.reduce(function (a, item) {
            return Math.max(a, item.w);
        }, 0);
        var ph = p.offsetHeight;
        return { w: pw, h: ph };
    });

    var curH = 0;var columns = 1;
    var curW = 0;
    var globalW = 0;
    var globalH = 0;
    var canUseFlex = true;
    partSizes.forEach(function (r) {
        if (r.h > availableHeight) canUseFlex = false;
        if (!canUseFlex) return;
        curH += r.h;
        curW = Math.max(curW, r.w);
        if (curH > availableHeight) {
            globalW += curW;
            globalH = Math.max(globalH, curH);
            columns++;
            curW = r.w;
            curH = r.h;
        }
    });
    globalW += curW;
    globalH = Math.max(globalH, curH);

    canUseFlex &= globalH > availableHeight && globalW < availableWidth;
    //canUseFlex = false;
    if (!canUseFlex) {
        song.classList.remove("agamaflex");
        setStyle(song, "height", "auto");
    } else {
        setStyle(song, "height", availableHeight + "px");
        song.classList.add("agamaflex");
    }

    var parts = (0, _from2.default)(elem.querySelectorAll('.part'));
    parts.forEach(function (part) {

        (0, _from2.default)(part.querySelectorAll('.line.chorded .middleLine')).forEach(function (elem) {
            setStyle(elem, "paddingLeft", "0px");
            setStyle(elem, "letterSpacing", "0px");
            //setStyle(elem, "color", "blue")
        });

        var lines = (0, _from2.default)(part.querySelectorAll('.line.chorded'));
        lines.forEach(repairLine);
    });
};
/*eslint-enable */


//////////////////
// WEBPACK FOOTER
// ./src/helpers/AgamaText.js
// module id = 162
// module chunks = 0